/*
 * @Author: zhao - 🍉
 * @Date: 2021-12-31 11:53:14
 * @LastEditTime: 2022-01-29 18:16:02
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账
 * @FilePath: /zhzj-admin/src/services/platformAccountingRecord.js
 */

import request from "../utils/request";

/**
 * 平台对账 - 对账列表
 * @param {*} params
 * @returns
 */
export function fetchPlatformRecordList(params) {
    return request({
        url: '/platform/verify/findPage',
        method: 'post',
        params
    })
}



/**
 * 平台对账 - 对账详情
 * @param {*} data
 * @returns
 */
export function fetchPlatformRecordGet(data) {
    return request({
        url: '/platform/verify/getPlatformReconciliationInfo',
        method: 'post',
        data
    })
}


/**
 * 平台对账 - 系统对账
 * @param {*} data
 * @returns
 */
 export function fetchPlatformRecordSynchronizeStatement (data) {
    return request({
        url: '/platform/verify/synchronizeStatement',
        method: 'post',
        data,
    })
}

/**
 * 平台对账 - 手动对账
 * @param {*} data
 * @returns
 */
export function fetchPlatformRecordManualReconciliation(data) {
    return request({
        url: '/platform/verify/manualReconciliation',
        method: 'post',
        data,
    })
}

/**
 * 平台对账 - 数字人民币对账单汇总列表
 * @param {*} data
 * @returns
 */
export function fetchPlatformRecordSzRmbPayOrderSummaryDataList(params) {
    return request({
        url: '/platform/verify/findSzRmbPayOrderSummaryDataPage',
        method: 'post',
        params
    })
}

/**
 * 平台对账 - 数字人民币对账单汇总列表->汇总数据订单明细数据
 * @param {*} data
 * @returns
 */
export function fetchPlatformRecordSzRmbPayOrderSummaryDataOrderInfoPage(params) {
    return request({
        url: '/platform/verify/findSzRmbPayOrderSummaryDataOrderInfoPage',
        method: 'post',
        params
    })
}
/**
 * 平台对账 - 数字人民币对账单汇总详情
 * @param {*} params
 * @returns
 */
 export function fetchPlatformRecordSzRmbPayOrderSummaryDataGet(params) {
    return request({
        url: '/platform/verify/getSzRmbPayOrderSummaryDataOrderInfoById',
        method: 'post',
        params
    })
}


/**
 * 平台对账 - 银联对账单汇总列表
 * @param {*} params
 * @returns
 */
 export function fetchPlatformRecordYlPayOrderSummaryList(params) {
    return request({
        url: '/platform/verify/findYlPayOrderSummaryDataPage',
        method: 'post',
        params
    })
}
/**
 * 平台对账 - 银联对账单->汇总数据终端明细
 * @param {*} params
 * @returns
 */
 export function fetchPlatformRecordYlPayOrderSummaryDataInfoPage(params) {
    return request({
        url: '/platform/verify/findYlPayOrderSummaryDataInfoPage',
        method: 'post',
        params
    })
}
/**
 * 平台对账 - 银联对账单->汇总数据订单明细数据
 * @param {*} params
 * @returns
 */
 export function fetchPlatformRecordYlPayOrderSummaryDataOrderInfoPage(params) {
    return request({
        url: '/platform/verify/findYlPayOrderSummaryDataOrderInfoPage',
        method: 'post',
        params
    })
}
/**
 * 平台对账 - 银联对账单->汇总数据订单明细数据->汇总数据订单明细数据详情
 * @param {*} params
 * @returns
 */
 export function fetchPlatformRecordYlPayOrderSummaryDataOrderInfoGet(params) {
    return request({
        url: '/platform/verify/getYlPayOrderSummaryDataOrderInfoById',
        method: 'post',
        params
    })
}




/**
 * 平台对账 - 银联分账账单系统汇总列表
 * @param {*} params
 * @returns
 */
 export function fetchPlatformRecordYlSharingPayOrderSummaryList(params) {
    return request({
        url: '/platform/verify/findYlSharingPayOrderSummaryDataPage',
        method: 'post',
        params
    })
}
/**
 * 平台对账 - 银联分账账单系统汇总列表->汇总数据订单明细数据
 * @param {*} params
 * @returns
 */
 export function fetchPlatformRecordYlSharingPayOrderSummaryDataOrderList(params) {
    return request({
        url: '/platform/verify/findYlSharingPayOrderSummaryDataOrderInfoPage',
        method: 'post',
        params
    })
}
/**
 * 平台对账 - 银联分账账单系统汇总列表->汇总数据订单明细数据->详情
 * @param {*} params
 * @returns
 */
 export function fetchPlatformRecordYlSharingPayOrderSummaryDataOrderGet(params) {
    return request({
        url: '/platform/verify/getYlSharingPayOrderSummaryDataOrderInfoById',
        method: 'post',
        params
    })
}




/**
 * 平台对账 - 惠市宝对账单汇总列表
 * @param {*} params
 * @returns
 */
 export function fetchPlatformRecordHsbPayOrderSummaryList(params) {
    return request({
        url: '/platform/verify/findHsbPayOrderSummaryDataPage',
        method: 'post',
        params
    })
}



/**
 * 平台对账 - 惠市宝对账单汇总列表->汇总数据订单明细数据
 * @param {*} params
 * @returns
 */
 export function fetchPlatformRecordHsbPayOrderSummaryDataOrderList(params) {
    return request({
        url: '/platform/verify/findHsbPayOrderSummaryDataOrderInfoPage',
        method: 'post',
        params
    })
}
/**
 * 平台对账 - 惠市宝对账单汇总列表->汇总数据订单明细数据->详情
 * @param {*} params
 * @returns
 */
 export function fetchPlatformRecordHsbPayOrderSummaryDataOrderGet(params) {
    return request({
        url: '/platform/verify/getHsbPayOrderSummaryDataOrderInfoById',
        method: 'post',
        params
    })
}



/**
 * 平台对账 - 威富通对账单汇总列表
 * @param {*} params
 * @returns
 */
export function fetchPlatformRecordWftPayOrderSummaryList(params) {
    return request({
        url: '/platform/wftPayDataOrderInfo/findSummaryPage',
        method: 'post',
        params
    })
}



/**
 * 平台对账 - 威富通对账单汇总列表->汇总数据订单明细数据
 * @param {*} params
 * @returns
 */
export function fetchPlatformRecordWftPayOrderSummaryDataOrderList(params) {
    return request({
        url: '/platform/wftPayDataOrderInfo/findWftPayDataOrderInfoPage',
        method: 'post',
        params
    })
}
/**
 * 平台对账 - 威富通对账单汇总列表->汇总数据订单明细数据->详情
 * @param {*} params
 * @returns
 */
export function fetchPlatformRecordWftPayOrderSummaryDataOrderGet(params) {
    return request({
        url: '/platform/wftPayDataOrderInfo/getWftPayDataOrderInfo',
        method: 'post',
        params
    })
}




// WEBPACK FOOTER //
// ./src/services/platformAccountingRecord.js